import { render } from "./Growth.vue?vue&type=template&id=9cab6d0a&scoped=true"
import script from "./Growth.vue?vue&type=script&lang=js"
export * from "./Growth.vue?vue&type=script&lang=js"

import "./Growth.vue?vue&type=style&index=0&id=9cab6d0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cab6d0a"]])

export default __exports__